export const shouldForwardProp = (propList: string[]) => {
    return (prop:string) => !propList.includes(prop);
}